import React from 'react'
import {Route} from 'react-router'
import VisibleSubjects from './containers/VisibleSubjects'

const subjectsRoute = <Route path='/subjects' component={VisibleSubjects} />
export default subjectsRoute



// WEBPACK FOOTER //
// ./src/domains/home/subjects/index.js